module.exports = __webpack_public_path__ + "img/page5Img1.8eceaee8.png";